import { render, staticRenderFns } from "./main-introduction.vue?vue&type=template&id=76c32b28&scoped=true"
import script from "./main-introduction.vue?vue&type=script&lang=js"
export * from "./main-introduction.vue?vue&type=script&lang=js"
import style0 from "./main-introduction.vue?vue&type=style&index=0&id=76c32b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c32b28",
  null
  
)

export default component.exports